import { promocodesAPI } from '@/services/promocodes'

export default {
  state: {
    list: null,
    params: null,
    categories: null,
    statistics: null,
    pagination: null,
    notification_email: null,
  },
  mutations: {
    setPromocodesList (state, data) {
      state.list = data
    },
    setPromocodesParams (state, data) {
      state.params = data
    },
    setPromocodesPagination (state, data) {
      state.pagination = data
    },
    setPromocodesStatistics (state, data) {
      state.statistics = data
    },
    setPromocodesNotificationEmail (state, data) {
      state.notification_email = data
    },
    setPromocodesCategories (state, categories) {
      state.categories = categories
    },
  },

  actions: {
    async fetchCategories({ commit }) {
      try {
        const response = await promocodesAPI.getCategories(this)
        
        if (response && response.categories) {
          commit('setPromocodesCategories', response.categories)
          return response.categories 
        }
        
        return null
      } catch (error) {
        console.error('Store action error:', error) // Для отладки
        return null
      }
    }
  },
  getters: {
    getPromocodesList: (state) => {
      return state.list
    },
    getPromocodesPagination: (state) => {
      return state.pagination
    },
    getPromocodesStatistics: (state) => {
      return state.statistics
    },
    getPromocodesNotificationEmail: (state) => {
      return state.notification_email
    },
    getPromocodesCategories: (state) => {
      return state.categories
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/promocodes.js